<template>
    <el-table width="850px" :data="repayPlan" v-if="repayPlan.length">
        <el-table-column prop="no" label="期次" width="100px"></el-table-column>
        <el-table-column prop="status_memo" label="计划回款日期" width="300px">
            <template slot-scope="scope">
                <span v-if="scope" class="cell-edit-input">
                    <el-date-picker
                            v-model="scope.row.plan_at"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                             :disabled="(scope.row.actual_at && scope.row.actual_at.trim() && scope.row.actual_amount > 0)  ?true:false"

                            placeholder="选择回款日期">
                    </el-date-picker>
                </span>
            </template>
        </el-table-column>
        <el-table-column prop="plan_amount" label="计划回款金额" width="200px">
            <template slot-scope="scope">
                <span v-if="scope" class="cell-edit-input"><el-input v-model.trim="scope.row.plan_amount"
                                                                    placeholder="请输入价格"   :disabled="(scope.row.actual_at && scope.row.actual_at.trim() && scope.row.actual_amount > 0)  ?true:false"></el-input></span>
            </template>
        </el-table-column>
        <el-table-column center label="操作"  width="200px">
            <template slot-scope="scope">
                <div>
                    <el-button type="text" size="small" disabled v-if="scope.row.actual_at && scope.row.actual_at.trim()&& scope.row.actual_amount>0">已回款</el-button>
                    <el-button type="text" size="small" v-show="Acs('/order/delete-pay-log')" :disabled="scope.row.actual_at>0 ?true:false" @click="handleDeletePay(scope.row)" v-else>删除</el-button>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="实际回款时间"  width="200px">
            <template slot-scope="scope">
                <span>{{scope.row.actual_at || '--'}}</span>
            </template>
        </el-table-column>
        <el-table-column label="实际回款金额"  width="200px">
            <template slot-scope="scope">
                   <span>{{scope.row.actual_amount || 0}}</span>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
    import OrderService from "~/services/order";

    export default {
        data() {
            return {
                pickerOptions1: {}
            }
        },
        props: {
            repayPlan: {
                type: Array,
                required: true
            }
        },
        methods: {
            handleDeletePay(row) {
                if (this.$route.path == '/order/edit') {
                    this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        OrderService.deletePayLog({id: row.id}).then((res) => {
                            if (res.code == 0) {
                                this.$emit('handleDel', row.no);
                            }
                        });
                    })
                }else{
                    this.$emit('handleDel', row.no);
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/payPlanTable.vue